const state = {
    timeZones: [],
    currencies: [],
    tags: [],
    recognitionClasses: [],
    clusterSizes: [],
    categories: [],
    codecs: [],
    checkinStayMode: [],
    regions: [],
    orderStatus: [],
    paymentMethods: {
        picaServiceId: null,
        methods: []
    },
    favouriteEligibility: {
        galleryId: null,
        options: []
    },
    anonymizeMode: [],
    shareMode: [],
    experienceType: [],
    purchaseTime: [],
    displayTime: [],
    hdStorageTypes: [],
    hdServingTypes: [],
    sdServingTypes: [],
    processingPriority: [],
    subGalleryDisplayTypes: [],
    compactDisplayTypes: [],
    expandedDisplayTypes: [],
}

const mapToLabelValue = (items) => items.map(item => ({
    label: item.label,
    value: item.id
}))


export const getters = {
    timeZones: state => state.timeZones,
    currencies: state => mapToLabelValue(state.currencies),
    clusterSizes: state => mapToLabelValue(state.clusterSizes),
    recognitionClasses: state => mapToLabelValue(state.recognitionClasses),
    categories: state => mapToLabelValue(state.categories),
    codecs: state => mapToLabelValue(state.codecs),
    checkinStayMode: state => mapToLabelValue(state.checkinStayMode),
    regions: state => mapToLabelValue(state.regions),
    orderStatus: state => state.orderStatus,
    paymentMethods: state => state.paymentMethods.methods,
    favouriteEligibility: state => mapToLabelValue(state.favouriteEligibility.options),
    anonymizeMode: state => mapToLabelValue(state.anonymizeMode),
    shareMode: state => mapToLabelValue(state.shareMode),
    experienceType: state => mapToLabelValue(state.experienceType),
    purchaseTime: state => mapToLabelValue(state.purchaseTime),
    displayTime: state => mapToLabelValue(state.displayTime),
    hdStorageTypes: state => mapToLabelValue(state.hdStorageTypes),
    hdServingTypes: state => mapToLabelValue(state.hdServingTypes),
    sdServingTypes: state => mapToLabelValue(state.sdServingTypes),
    processingPriority: state => mapToLabelValue(state.processingPriority),
    subGalleryDisplayTypes: state => mapToLabelValue(state.subGalleryDisplayTypes),
    compactDisplayTypes: state => mapToLabelValue(state.compactDisplayTypes),
    expandedDisplayTypes: state => mapToLabelValue(state.expandedDisplayTypes),
}


export const mutations = {
    resetCache(state) {
        state.timeZones = []
        state.currencies = []
        state.tags = []
        state.recognitionClasses = []
        state.clusterSizes = []
        state.categories = []
        state.codecs = []
        state.checkinStayMode = []
        state.regions = []
        state.orderStatus = []
        state.paymentMethods = {
            picaServiceId: null,
            methods: []
        }
        state.favouriteEligibility = {
            galleryId: null,
            options: []
        }
        state.anonymizeMode = []
        state.shareMode = []
        state.experienceType = []
        state.purchaseTime = []
        state.displayTime = []
        state.hdStorageTypes = []
        state.hdServingTypes = []
        state.sdServingTypes = []
        state.processingPriority = []
        state.subGalleryDisplayTypes = []
        state.compactDisplayTypes = []
        state.expandedDisplayTypes = []
    },
    setTimeZones(state, timeZones) {
        state.timeZones = timeZones
    },
    setCurrencies(state, currencies) {
        state.currencies = currencies
    },
    recognitionClasses(state, recognitionClasses) {
        state.recognitionClasses = recognitionClasses
    },
    clusterSizes(state, clusterSizes) {
        state.clusterSizes = clusterSizes
    },
    categories(state, categories) {
        state.categories = categories
    },
    codecs(state, codecs) {
        state.codecs = codecs
    },
    checkinStayMode(state, checkinStayMode) {
        state.checkinStayMode = checkinStayMode
    },
    regions(state, regions) {
        state.regions = regions
    },
    orderStatus(state, orderStatus) {
        state.orderStatus = orderStatus
    },
    paymentMethods(state, {picaServiceId, methods}) {
        state.paymentMethods = {
            picaServiceId: picaServiceId,
            methods: methods
        }
    },
    favouriteEligibility(state, {galleryId, options}) {
        state.favouriteEligibility = {
            galleryId: galleryId,
            options: options
        }
    },
    anonymizeMode(state, anonymizeMode) {
        state.anonymizeMode = anonymizeMode
    },
    shareMode(state, shareMode) {
        state.shareMode = shareMode
    },
    experienceType(state, experienceType) {
        state.experienceType = experienceType
    },
    purchaseTime(state, purchaseTime) {
        state.purchaseTime = purchaseTime
    },
    displayTime(state, displayTime) {
        state.displayTime = displayTime
    },
    hdStorageTypes(state, hdStorageTypes) {
        state.hdStorageTypes = hdStorageTypes
    },
    hdServingTypes(state, hdServingTypes) {
        state.hdServingTypes = hdServingTypes
    },
    sdServingTypes(state, sdServingTypes) {
        state.sdServingTypes = sdServingTypes
    },
    setProcessingPriority(state, processingPriority) {
        state.processingPriority = processingPriority
    },
    setSubGalleryDisplayTypes(state, subGalleryDisplayTypes) {
        state.subGalleryDisplayTypes = subGalleryDisplayTypes
    },
    setCompactDisplayTypes(state, compactDisplayTypes) {
        state.compactDisplayTypes = compactDisplayTypes
    },
    setExpandedDisplayTypes(state, expandedDisplayTypes) {
        state.expandedDisplayTypes = expandedDisplayTypes
    },
}


export const actions = (tagService, coreService) => ({
    fetchTimeZones: async function ({commit, getters}) {
        if (getters.timeZones.length) return
        commit('setTimeZones', await coreService.fetchTimezones())
    },
    fetchCurrencies: async function ({commit, getters}) {
        if (getters.currencies.length) return
        commit('setCurrencies', await coreService.fetchCurrencies())
    },
    // eslint-disable-next-line no-unused-vars
    autocompleteTags: async function ({commit}, query) {
        if (typeof query === 'object') {
            const {query: q, category} = query
            return await tagService.autocompleteTags(q, category)
        }
        return await tagService.autocompleteTags(query)
    },
    async fetchRecognitionClasses({commit, getters}) {
        if (getters['recognitionClasses'].length) return
        commit('recognitionClasses', await coreService.fetchRecognitionClasses())
    },
    async fetchClusterSizes({commit, getters}) {
        if (getters['clusterSizes'].length) return
        commit('clusterSizes', await coreService.fetchClusterSizes())
    },
    async fetchCategories({commit, getters}) {
        if (getters['categories'].length) return
        commit('categories', await coreService.fetchCategories())
    },
    async fetchCodecs({commit, getters}) {
        if (getters['codecs'].length) return
        commit('codecs', await coreService.fetchCodecs())
    },
    async fetchCheckinStayMode({commit, getters}) {
        if (getters['checkinStayMode'].length) return
        commit('checkinStayMode', await coreService.fetchCheckinStayMode())
    },
    async fetchRegions({commit, getters}) {
        if (getters['regions'].length) return
        commit('regions', await coreService.fetchRegions())
    },
    async fetchOrderStatus({commit, getters}) {
        if (getters['orderStatus'].length) return
        commit('orderStatus', await coreService.fetchOrderStatus())
    },
    async fetchPaymentMethods({commit, state}, picaServiceId) {
        if (state.paymentMethods.picaServiceId === picaServiceId && state.paymentMethods.methods.length > 0) return

        // Avoid showing different picaServiceId payment methods until we fetch the new ones
        commit('paymentMethods', {
            picaServiceId: null,
            methods: [],
        })

        commit('paymentMethods', {
            picaServiceId: picaServiceId,
            methods: await coreService.fetchPaymentMethods(picaServiceId),
        })
    },
    async fetchFavouriteEligibility({commit, state}, galleryId) {
        if (state.favouriteEligibility.galleryId === galleryId && state.favouriteEligibility.options.length > 0) return

        commit('favouriteEligibility', {
            galleryId: galleryId,
            options: await coreService.fetchFavouriteEligibility(galleryId),
        })
    },
    async fetchAnonymizeMode({commit, getters}) {
        if (getters['anonymizeMode'].length) return
        commit('anonymizeMode', await coreService.fetchAnonymizeMode())
    },
    async fetchShareMode({commit, getters}) {
        if (getters['shareMode'].length) return
        commit('shareMode', await coreService.fetchShareMode())
    },
    async fetchExperienceType({commit, getters}) {
        if (getters['experienceType'].length) return
        commit('experienceType', await coreService.fetchExperienceType())
    },
    async fetchPurchaseTime({commit, getters}) {
        if (getters['purchaseTime'].length) return
        commit('purchaseTime', await coreService.fetchPurchaseTime())
    },
    async fetchDisplayTime({commit, getters}) {
        if (getters['displayTime'].length) return
        commit('displayTime', await coreService.fetchDisplayTime())
    },
    async fetchHdStorageTypes({commit, getters}) {
        if (getters['hdStorageTypes'].length) return
        commit('hdStorageTypes', await coreService.fetchHdStorageTypes())
    },
    async fetchHdServingTypes({commit, getters}) {
        if (getters['hdServingTypes'].length) return
        commit('hdServingTypes', await coreService.fetchHdServingTypes())
    },
    async fetchSDServingTypes({commit, getters}) {
        if (getters['sdServingTypes'].length) return
        commit('sdServingTypes', await coreService.fetchSdServingTypes())
    },
    async fetchProcessingPriority({commit, getters}) {
        if (getters['processingPriority'].length) return
        commit('setProcessingPriority', await coreService.fetchProcessingPriority())
    },
    async fetchSubGalleryDisplayTypes({commit, getters}) {
        if (getters['subGalleryDisplayTypes'].length) return
        commit('setSubGalleryDisplayTypes', await coreService.fetchSubGalleryDisplayTypes())
    },
    async fetchCompactDisplayTypes({commit, getters}) {
        if (getters['compactDisplayTypes'].length) return
        commit('setCompactDisplayTypes', await coreService.fetchCompactDisplayTypes())
    },
    async fetchExpandedDisplayTypes({commit, getters}) {
        if (getters['expandedDisplayTypes'].length) return
        commit('setExpandedDisplayTypes', await coreService.fetchExpandedDisplayTypes())
    },
    resetCache({commit}) {
        commit('resetCache')
    }
})

export default (tagService, coreService) => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(tagService, coreService)
})